import React from "react";
import UserMenu from "./UserMenu";
import ThemeToggle from "./ThemeToggle";
import { useThemeContext } from "../../providers/ThemeProvider";
import cecisCheckInk from "../../assets/cecis-check-ink.svg";
import cecisCheckLight from "../../assets/cecis-check.svg";

// Sem título de tela: o <h1> é da página, e repeti-lo aqui daria dois títulos
// concorrentes na mesma coluna.
function Header() {
  // O wordmark é <img src>, não SVG inline, então currentColor não o alcança:
  // a variante clara já existia para o painel escuro do Login e é a mesma que
  // serve ao header no tema escuro.
  const { resolved } = useThemeContext();

  return (
    <header className="appbar">
      <div className="appbar-inner">
        <img
          className="appbar-logo"
          src={resolved === "dark" ? cecisCheckLight : cecisCheckInk}
          alt="Cecis Check"
        />
        <div className="appbar-actions">
          <ThemeToggle />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}

export default Header;
